import React from "react";
import { motion } from "framer-motion";
import { FlaskConical, Lock, Mail, Network, Sparkles, Users, Zap } from "lucide-react";
import { useQuantum } from "./QuantumTransitions";
import { useAuth } from "../context/AuthContext";

const DOORS = [
  { key: "multiverse", label: "Multiverse map", desc: "See every version of you branch out like a constellation.", icon: Network, color: "#00F0FF" },
  { key: "council", label: "Council of You", desc: "Five selves, five priorities, one question.", icon: Users, color: "#FFD700", premium: true },
  { key: "collide", label: "Collide timelines", desc: "Compare two selves and let them talk.", icon: Zap, color: "#B026FF", premium: true },
  { key: "lab", label: "Possibility Lab", desc: "Butterfly effect, money paths, regret reversal.", icon: FlaskConical, color: "#7CFFB2" },
  { key: "letters", label: "Letters from the future", desc: "A personal letter from a future you.", icon: Mail, color: "#FF6AD5" },
];

export const QuantumHub = ({ journey }) => {
  const { go } = useQuantum();
  const { user } = useAuth();
  const hasDecisions = !!journey.five_decisions?.length;
  return (
    <div className="mt-6" data-testid="quantum-hub">
      <motion.button onClick={() => go(`/decisions/${journey.id}`)} whileHover={{ y: -3 }} data-testid="hub-five-decisions"
        className="w-full glass rounded-3xl p-6 text-left flex items-center gap-5" style={{ borderColor: "rgba(176,38,255,0.5)", boxShadow: "0 0 30px rgba(176,38,255,0.2)" }}>
        <Sparkles className="text-purple-300 shrink-0" />
        <div className="flex-1">
          <div className="font-mono-label text-purple-200 mb-1">{hasDecisions ? "Your Five Decisions" : "New · The Five Decisions"}</div>
          <div className="font-display text-xl md:text-2xl">What if you could meet the version of yourself who chose differently?</div>
        </div>
      </motion.button>
      {hasDecisions && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mt-3">
          {DOORS.map((d, i) => {
            const Icon = d.icon;
            const locked = d.premium && !user?.is_premium;
            return (
              <motion.button key={d.key} onClick={() => go(`/${d.key}/${journey.id}`)} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.07 }}
                whileHover={{ y: -3 }} className="glass rounded-2xl p-4 text-left relative" style={{ borderColor: `${d.color}44` }} data-testid={`hub-${d.key}`}>
                {locked && <Lock size={12} className="absolute top-3 right-3 text-amber-300/70" aria-label="Premium" />}
                <Icon size={18} style={{ color: d.color }} className="mb-2" />
                <div className="font-display text-sm mb-1">{d.label}</div>
                <div className="text-[11px] text-white/45 leading-snug">{d.desc}</div>
              </motion.button>
            );
          })}
        </div>
      )}
    </div>
  );
};
